<template>
    <div class="animated fadeIn">
        <div class="animated fadeIn">
            <div class="card card-default">
                <div class="card-header">
                     Create a proposal
                </div>
                <div class="card-body">
<!--                    <button class="btn btn-primary">Create a proposal</button>-->
                    <router-link to="/proposal/create" style="color: #fff !important">
                        <button class="btn btn-primary">Create a proposal</button>
                    </router-link>
                </div>
            </div>
        </div>

        <hr>

    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";

    export default {
        name: 'dashboard',
        components: {},
        data() {
            return {

            };
        },
        methods: {

        },
        mounted() {


        }

    }
</script>

<style scoped>

    .small-text {
        color: #73818f;
    }

    .h1 {
        margin-bottom: 0rem !important;
    }

</style>>


